<div class="grid-wrap-container">
  <header></header>
  <main>
    <h1>Проект Продом</h1>
    <tui-icon icon="@tui.origami"></tui-icon>
    <p>Этот сайт является временной заглушкой</p>
  </main>
  <footer></footer>
</div>
